<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<b-row class="justify-content-center">
				<b-col md="8" lg="6">
					<b-card-group>
						<b-card no-body class="p-4">
							<b-card-body>
								<b-alert
									variant="success"
									:show="dismissCountDown"
									fade
									dismissible
									class="text-center"
									@dismissed="dismissCountDown=0"
									@dismiss-count-down="countDownChanged">
									<strong>{{successMessage}}</strong>
									<b-progress
										variant="success"
										:max="dismissSecs"
										:value="dismissCountDown"
										height="4px"
									></b-progress>
								</b-alert>
								<b-form @submit="requestPassword">
									<b-img center src="../img/brand/LOGO SPC.png" alt="Center image"></b-img>
									<br>
									<h5 class="text-muted">Recuperar Contraseña</h5>
									<b-input-group class="mb-3">
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-envelope"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input
											type="email"
											class="form-control"
											placeholder="Correo Electrónico"
											autocomplete="username email"
											v-model="email"
											required/>
									</b-input-group>
									<b-row>
										<b-col v-if="errorMessage" cols="12" class="mb-3">
											<h6 class="text-danger">{{errorMessage}}</h6>
										</b-col>
										<b-col cols="6" class="text-left">
											<router-link :to="{name: 'Login'}">Iniciar Sesión</router-link>
										</b-col>
										<b-col cols="6" class="d-flex justify-content-end">
											<b-button type="submit" v-if="!loading" variant="primary" class="px-4">
												Enviar
											</b-button>
											<i v-if="loading" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
											<span class="sr-only">Loading...</span>
										</b-col>

									</b-row>
								</b-form>
							</b-card-body>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ForgotPassword",
		data: function () {
			return {
				loading: false,
				email: '',
				errorMessage: '',
				successMessage: '',
				dismissSecs: 5,
				dismissCountDown: 0,
			}
		},
		methods: {
			requestPassword(evt) {
				evt.preventDefault();

				this.loading = true;

				let forgotPassword = {
					email: this.email,
					url: process.env.VUE_APP_FRONT_URL + '#/set-password/'
				};
				this.$store.dispatch('forgotPassword', forgotPassword)
					.then((response) => {
						this.email = '';
						this.dismissCountDown = this.dismissSecs;
						this.successMessage = response;
					})
					.catch((err) => {
						if (err.status === 400) {
							if (err.data.ModelState) {

							} else {
								this.errorMessage = err.data.Message;
							}
						}
					})
					.finally(() => {
						this.loading = false;
					})
			},
			countDownChanged(dismissCountDown) {
				this.dismissCountDown = dismissCountDown
			},
		}
	}
</script>

<style scoped>

</style>
